<template>
    <div class="withdraw-record">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.fail}}</span>
        </alart-msg>
        <modal class="withdraw-modal" :display="withdrawModal"  @modalStatus="closeModal('withdraw')" >
            <h1>輸入提領金額</h1>
            <div class="content" v-if="withdrawState == 0">
                <div class="name">
                    <span>可提領餘額</span>
                    <div class="money">
                        <span class="sign">
                            $
                        </span>
                        <div class="number">
                            {{toCurrency(userBalance)}}
                        </div>
                    </div>
                </div>
                <div class="price">
                    <span>提領金額</span>
                    <div class="input-error-group">
                        <input type="text" v-model="withdraw.price" >
                        <span v-show="error.withdraw" class="error">{{error.withdraw}}</span>
                    </div>
                </div>
                <div class="bank" >
                    <span>選擇提領帳戶</span>
                    <rent-select :key="componentKey" refName="bank" :selectMsg="defaultBankName" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li :data-id="card.bankAccountCid" :data-name="card.bankName.bankName" :data-acc="bankAccountEncrypt(card.accountNo)" v-for="(card,index) in bankCardList" :key="index">
                                {{card.bankName.bankName}}帳戶 （ {{bankAccountEncrypt(card.accountNo)}}）
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="content" v-if="withdrawState == 1">
                <div class="list">
                    <span class="title">申請時間</span>
                    <span class="info">{{today}}</span>
                </div>
                <div class="list">
                    <span class="title">轉入帳號</span>
                    <span class="info">{{seletedBank.name}}帳戶 （ {{seletedBank.account}}）</span>
                </div>
                <div class="list">
                    <span class="title">提領金額</span>
                    <span class="info">$ {{toCurrency(withdraw.price)}}</span>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" v-if="withdrawState == 0" :disabled="disabledState" @click="withdrawState=1">下一步</button>
                <button class="default-button" v-if="withdrawState == 1" @click="withdrawAmount">確認提領</button>
                <button class="border-button" @click="closeModal('withdraw')">取消</button>
            </div>
        </modal>
        <div class="wallet-tool-bar">
            <div class="filter" :class="{'fixed': listIsFixed}">
                <rent-select refName="withdraw" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li data-id="SUCCESS">成功</li>
                        <li data-id="WITHDRAW_FAILED">失敗</li>
                        <li data-id="WITHDRAW_AUDITING">等待中</li>
                    </ul>
                </rent-select>
                <date-picker v-model="withdrawPeriod" :class="{'active': withdrawPeriod.length > 0}" placeholder="請選擇日期" format="YYYY.MM.DD"  rangeSeparator="-" range  ></date-picker>
            </div>
            <div class="stored">
                <div class="money">
                    <span class="sign">
                        帳戶餘額
                    </span>
                    <div class="number">
                        {{toCurrency(userTotalBalance)}}
                    </div>
                </div>
                <button class="default-button" @click="withdrawEvent()">提領</button>
            </div>
        </div>
        <div class="table-list withdraw" >
            <div class="table-list-title">
                <span class="date">申請提領時間</span>
                <span class="bank">提領至</span>
                <span class="price">金額</span>
                <span class="state">狀態</span>
                <span class="reason">失敗原因</span>
                <span class="number">提領編號</span>
            </div>
            <div class="table-list-body" >
                <div v-if="withdrawList.length != 0 && filterByContractDate.length == 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <button class="default-button" @click="setFilterDefault">清除篩選</button>
                </div>
                <div v-if="withdrawList.length == 0" class="is-empty">
                    0 筆資料
                </div>
                <ul>
                    <li v-for="(bill,index) in filterByContractDate" :key="index">
                        <span class="date">{{getFormatDate(bill.createdDate)}}</span>
                        <span class="bank">
                            <img :src="'../../../../../static/img/bank/'+bill.bankCode+'.png'" alt="">
                            {{bill.bankName}}
                        </span>
                        <span class="price">{{toCurrency(bill.amount)}}</span>
                        <span class="state blue" v-if="bill.transactionStatus == 'SUCCESS'">成功</span>
                        <span class="state red" v-if="bill.transactionStatus == 'WITHDRAW_FAILED'">失敗</span>
                        <span class="state gray" v-if="bill.transactionStatus == 'WITHDRAW_AUDITING'">等待中</span>
                        <span class="reason">{{bill.withdrawFailReason? bill.withdrawFailReason : '-'}}</span>
                        <span class="number">{{transIdEncrypt(bill.transactionId)}}</span>
                    </li>
                </ul>
            </div> 
        </div> 
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import walletStoredInfo from '@/components/widge/modal/walletStoredInfo.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';

import { mapGetters } from 'vuex'
import { 
    apiGetBalance,
    apiWithwraw
} from "@/apis/api.js"; 
export default {
    data () {
        return {
            componentKey: 0,
            disabledState: true,
            isDefault: false,
            withdrawState: 0,
            withdrawFilterState: null,
            withdrawModal: false,
            withdrawPeriod: [],
            filterEmpty: false,
            withdrawListDataEmpty: false,
            withdrawListDataError: false,
            isLoading: false,
            defaultBankName: null,
            listIsFixed: false,
            seletedBank: {
                name: null,
                account: null,
            },
            withdraw:{
                price: null,
                account: null
            },
            error:{
                withdraw: ''
            },
            filter: {
                payWay: null,
                date: null
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                fail: null,
            }
        }
    },
    mounted () {
        this.$store.dispatch('getBankCardList')
        this.$store.dispatch('getTransRecord', 1)
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        withdraw: {
            handler: function (newValue, oldValue) {
                let numerical = /^[0-9]*$/
                if(newValue.price){
                    if( numerical.test(newValue.price) ){
                        this.error.withdraw = ''
                        if( newValue.price > parseFloat(this.userBalance)){
                            this.error.withdraw = '餘額不足'
                        }else if(newValue.price > 100000){
                            this.error.withdraw = '最大提領金額為10萬'
                        }else{
                            this.error.withdraw = ''
                        }
                    }else{
                        this.error.withdraw = '請輸入數字'
                    }
                }
                // 房租
                if( newValue.price && newValue.account && !this.error.withdraw){
                    this.disabledState = false
                }else{
                    this.disabledState = true
                }
                // this.$store.dispatch('setHouseList',newValue)
            },
            deep: true
        },
        bankCardList: {
            handler: function (val) {
                // console.log(val)
                this.defaultBankInfo(val)
            },
            deep: true
        },
    },
    methods: {
        handleScroll (event) {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
        
            if( scrollTop >= 255){
                this.listIsFixed = true
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }
        },
        defaultBankInfo: function (bankList) {
            bankList.map( item =>{
                if(item.isDefaultBankAccount == true){
                    this.componentKey += 1;
                    this.withdraw.account = item.bankAccountCid
                    this.defaultBankName = item.bankName.bankName+'（'+ this.bankAccountEncrypt(item.accountNo) +'）'
                    this.seletedBank.account = this.bankAccountEncrypt(item.accountNo)
                    this.seletedBank.name = item.bankName.bankName
                }
            })
        },
        withdrawAmount: function () {
            this.$analytics.logEvent('送出提領', { screen_name: '送出提領'})
            let data = {
                "bankAccountId" : this.withdraw.account,
                "currencyType" : "TWD",
                "withdrawAmount" : this.withdraw.price
            }

            apiWithwraw(data)
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.closeModal('withdraw')
                    this.$store.dispatch('getUserBalance')
                    this.$store.dispatch('getTransRecord', 1)
                    this.alart.success = true
                    this.msg.success = '提領審核中'
                }else{
                    this.alart.fail = true
                    this.msg.fail = res.data.errorMsg
                    this.closeModal('withdraw')
                }
            })
            .catch(err => {
                this.alart.fail = true
                this.msg.fail = err
                console.log(err)
            })
        },
        getSelectId: function (value) {
            this.isDefault = false

            if( value.ref == 'bank' ){
                this.withdraw.account = event.target.dataset.id
                this.seletedBank.name = event.target.dataset.name
                this.seletedBank.account = event.target.dataset.acc
            }else if( value.ref == 'withdraw' ){
                this.withdrawFilterState = value.id
            }
        },
        withdrawEvent: function () {
            if(parseFloat(this.userBalance) > 0){
                this.withdrawModal = true
                document.getElementsByClassName('member-center')[0].style.zIndex = '9'
                this.$store.commit('modalStatus/set_modal_mode', true)
            }else{
                let data = {
                    type: 'error',
                    msg: '餘額不足'
                }
                this.$store.dispatch('setAlarmMsg',data)
            }
        },
        infoEvent: function () {
            document.getElementsByClassName('member-center')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.infoModal = true

        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            document.getElementsByClassName('member-center')[0].style.zIndex = '8'
            if( type == 'withdraw' ){
                this.withdrawModal = false
                this.withdrawState = 0
                this.withdraw.price = null
                this.withdraw.account = null
            }else if( type == 'infoModal' ){
                this.infoModal = false
            }
        },
        editNickName: function () {
            this.$analytics.logEvent('編輯出租人姓名', { screen_name: '編輯出租人姓名'})
            document.getElementsByClassName('member-center')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'addNickName'})
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        bankAccountEncrypt: function (account) {
            return '*****'+account.substr(5)
        },
        setFilterDefault: function () {
            this.isDefault = true
            this.withdrawPeriod = []
            this.withdrawFilterState = null
        },
        getFormatDate: function (date){
            var formatDate = [];
            var date = new Date(date);
            // var date = new Date(Date.parse(date));
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4];
            // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        },
        transIdEncrypt: function (id) {
            return id.substr(0,5)+'...'
        }
    },
    computed: {
        today: function () {
            if(this.withdrawState == 1){
                var formatDate = [];
                var date = new Date();
                //一般日期 年 月 天 時 分
                formatDate[0] = date.getFullYear();
                formatDate[1] = date.getMonth()+1;
                formatDate[2] = date.getDate();
                formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
                formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
                formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
                //月及天兩位數
                formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
                formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
                // console.log(formatDate[3] )
                //換算時區 台灣-8
                // if(formatDate[3] - 8 < 0){
                //     formatDate[3] = 24+(formatDate[3]-8);
                //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
                // }else{
                //     formatDate[3] = formatDate[3]-8;
                //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
                // }
                return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
            }
        },
        withdrawFilterByState: function () {
            return this.withdrawList.filter((withdrawItem) => {
                if( this.withdrawFilterState ){
                    if( withdrawItem.transactionStatus == this.withdrawFilterState ){
                        return withdrawItem
                    }
                }else{
                    return withdrawItem
                }
            });
        },
        filterByContractDate: function () {
            return this.withdrawFilterByState.filter((withdrawItem) => {
                if( this.withdrawPeriod[0] && this.withdrawPeriod[1] ){
                    let withdrawDate = withdrawItem.createdDate,
                        filterDateStart = Date.parse(this.withdrawPeriod[0]).valueOf(),
                        filterDateEnd = Date.parse(this.withdrawPeriod[1]).valueOf()+86400000
                    if( filterDateStart <= withdrawDate && withdrawDate <= filterDateEnd ){
                        return withdrawItem
                    }
                }else{
                    return withdrawItem
                }
            });
        },
        filterResult: function () {
             if( this.withdrawListDataEmpty == false && this.withdrawListDataError == false && this.isLoading == false ){
                if( this.filterByContractDate.length == 0 ){
                    this.filterEmpty = true
                }else{
                    this.filterEmpty = false
                    return this.filterByContractDate
                }
            }
        },
        ...mapGetters({
            userBalance: 'GET_USER_BALANCE',
            userTotalBalance: 'GET_USER_TOTAL_BALANCE',
            withdrawList: 'GET_MEMBER_TRANS_LIST',
            bankCardList: 'GET_MEMBER_BANK_CARD_LIST',

        })
    },
    components: {
        RentSelect,
        DatePicker,
        walletStoredInfo,
        Modal,
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .withdraw-record{
        padding: 0 30px;
        .wallet-tool-bar{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .filter.fixed{
                position: fixed;
                z-index: 50;
                margin-left: 785px;
                background: #fff;
                top: 0px;
                height: 80px;
                align-items: center;
            }
            .filter{
                display: flex;
                .rent-select{
                    width: 75px;
                }
                .mx-datepicker{
                    width: 214px;
                    margin-left: 16px;
                    input{
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
            }
            .stored{
                display: flex;
                .money{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-right: 16px;
                    .sign{
                        color: #292625;
                        margin-right: 4px;
                    }
                    .number{
                        color: #ff9275;
                        margin-left: 6px;
                        font-size: 28px;
                    }
                }
                .default-button{
                    width: 120px;
                }
            }
        }
        .withdraw-modal{
            .modal-content{
                width: 448px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin: 0 auto;
                        margin-top: 36px;
                        margin-bottom: 24px;
                    }
                    .alarm-msg{
                        padding: 8px 32px;
                        margin-bottom: 30px;
                        font-size: 16px;
                        font-weight: 500;
                        color: #fc7171;
                        background-color: rgba(240, 90, 62, 0.1);
                        line-height: 1.7;
                    }
                    .content{
                        min-height: 336px;
                        padding: 0 32px 10px 32px;
                        // margin-bottom: 52px;
                        >div{
                            margin-bottom: 30px;
                            >span{
                                display: block;
                                margin-bottom: 12px;
                            }
                            input{
                                width: 352px;
                            }
                        }
                        .price{
                            margin-bottom: 48px;
                        }
                        .bank{
                            span{
                                color: #676362 !important;
                            }
                        }
                        .list{
                            display: flex;
                            margin-bottom: 20px;
                            .title{
                                display: block;
                                width: 56px;
                                color: #a8a5a4;
                                margin-right: 22px;
                            }
                        }
                        .money{
                            position: relative;
                            display: flex;
                            align-items: flex-end;
                            color: #ff9275;
                            .sign{
                                position: absolute;
                                font-size: 12px;
                                font-weight: 500;
                                bottom: 5px;
                                color: #ff9275;
                            }
                            .number{
                                margin-left: 12px;
                                font-size: 32px;
                            }
                        }
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
        .withdraw{
            position: relative;
            width: 1094px;
            border-radius: 0px;
            border: 0px;
            border-bottom: 1px solid #f0f0f0;
            border-top: 1px solid #f0f0f0;
            .table-list-body ul li .bank{
                display: flex;
                align-items: center;
                >img{
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
            .table-list-body ul li .state{
                display: flex;
                align-items: center;
                justify-content: center;
                height: 38px;
                border-radius: 4px;
            }
            .table-list-body ul li .state.blue{
                background-color: #f0f6fc;
                color: #71aae5;
            }.table-list-body ul li .state.red{
                background-color: rgba(240, 90, 62, 0.1);
                color: #fc7171;
            }.table-list-body ul li .state.gray{
                background-color: #f6f6f6;
                color: #a8a5a4;
            }
            .table-list-title .date,
            .table-list-body ul li .date{
                width: 112px;
                margin-right: 94px;
            }
            .table-list-title .bank,
            .table-list-body ul li .bank{
                position: relative;
                width: 126px;
                margin-right: 45px;
            }
            .table-list-title .price,
            .table-list-body ul li .price{
                width: 74px;
                margin-right: 64px;
                text-align: right;
            }
            .table-list-title .state,
            .table-list-body ul li .state{
                width: 76px;
                margin-right: 91px;
            }
            .table-list-title .reason,
            .table-list-body ul li .reason{
                width: 200px;
                margin-right: 85px;
            }
            // .table-list-title .number,
            // .table-list-body ul li .number{
            //     width: 80px;
            //     margin-right: 55px;
            // }
            
        }
    }
    @media screen and (max-width: 1280px) {
        .withdraw-record{
            .wallet-tool-bar{
                .filter.fixed{
                    margin-left: 771px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/memberWallet/withdrawRecord.vue